/**
 * Tive API
 *
 * Contact: support@tive.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpContext,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { AssignDevicesRequest } from '../model/assignDevicesRequest';
// @ts-ignore
import { AssignmentItem } from '../model/assignmentItem';
// @ts-ignore
import { AssignmentValidationResponse } from '../model/assignmentValidationResponse';
// @ts-ignore
import { CheckDeviceResult } from '../model/checkDeviceResult';
// @ts-ignore
import { Company } from '../model/company';
// @ts-ignore
import { CompanyAccountWithAccess } from '../model/companyAccountWithAccess';
// @ts-ignore
import { CompanyCustomerDeviceListItemListLengthResult } from '../model/companyCustomerDeviceListItemListLengthResult';
// @ts-ignore
import { DeviceFamily } from '../model/deviceFamily';
// @ts-ignore
import { LoginUser } from '../model/loginUser';
// @ts-ignore
import { ODataResponse } from '../model/oDataResponse';
// @ts-ignore
import { OrganizationListItem } from '../model/organizationListItem';
// @ts-ignore
import { Permissions } from '../model/permissions';
// @ts-ignore
import { ReceiveDevicesRequest } from '../model/receiveDevicesRequest';
// @ts-ignore
import { RegisterDevice } from '../model/registerDevice';
// @ts-ignore
import { RegisterDevicesResponse } from '../model/registerDevicesResponse';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService } from '../api.base.service';

@Injectable({
  providedIn: 'root',
})
export class AdminService extends BaseService {
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration?: Configuration,
  ) {
    super(basePath, configuration);
  }

  /**
   * Get accounts and organizations for order
   * @endpoint get /api/Admin/accounts
   * @param organizationId
   * @param authorizedCompaniesOnly
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAdminAccountsGet(
    organizationId?: string,
    authorizedCompaniesOnly?: boolean,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<Array<CompanyAccountWithAccess>>;
  public apiAdminAccountsGet(
    organizationId?: string,
    authorizedCompaniesOnly?: boolean,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<Array<CompanyAccountWithAccess>>>;
  public apiAdminAccountsGet(
    organizationId?: string,
    authorizedCompaniesOnly?: boolean,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<Array<CompanyAccountWithAccess>>>;
  public apiAdminAccountsGet(
    organizationId?: string,
    authorizedCompaniesOnly?: boolean,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'organizationId',
      <any>organizationId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'authorizedCompaniesOnly',
      <any>authorizedCompaniesOnly,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/Admin/accounts`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<CompanyAccountWithAccess>>(
      'get',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters.toHttpParams(),
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Activate an organization that has been deactivated before (Role Permissions Required: ManageOrganizations)
   * @endpoint get /api/Admin/activateOrganization
   * @param organizationId
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAdminActivateOrganizationGet(
    organizationId?: string,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<boolean>;
  public apiAdminActivateOrganizationGet(
    organizationId?: string,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<boolean>>;
  public apiAdminActivateOrganizationGet(
    organizationId?: string,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<boolean>>;
  public apiAdminActivateOrganizationGet(
    organizationId?: string,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'organizationId',
      <any>organizationId,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/Admin/activateOrganization`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<boolean>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Assign devices to account (Role Permissions Required: TrackersAssignToOrganization)
   * @endpoint post /api/Admin/assignDevices
   * @param xTiveAccountId Account Id
   * @param assignDevicesRequest
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAdminAssignDevicesPost(
    xTiveAccountId?: number,
    assignDevicesRequest?: AssignDevicesRequest,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<boolean>;
  public apiAdminAssignDevicesPost(
    xTiveAccountId?: number,
    assignDevicesRequest?: AssignDevicesRequest,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<boolean>>;
  public apiAdminAssignDevicesPost(
    xTiveAccountId?: number,
    assignDevicesRequest?: AssignDevicesRequest,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<boolean>>;
  public apiAdminAssignDevicesPost(
    xTiveAccountId?: number,
    assignDevicesRequest?: AssignDevicesRequest,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json;odata.metadata=minimal;odata.streaming=true',
      'application/json;odata.metadata=minimal;odata.streaming=false',
      'application/json;odata.metadata=minimal',
      'application/json;odata.metadata=full;odata.streaming=true',
      'application/json;odata.metadata=full;odata.streaming=false',
      'application/json;odata.metadata=full',
      'application/json;odata.metadata=none;odata.streaming=true',
      'application/json;odata.metadata=none;odata.streaming=false',
      'application/json;odata.metadata=none',
      'application/json;odata.streaming=true',
      'application/json;odata.streaming=false',
      'application/json',
      'application/xml',
      'text/plain',
      'application/json-patch+json',
      'text/json',
      'application/*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/Admin/assignDevices`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<boolean>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: assignDevicesRequest,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Returns a list of authorized organization for this user
   * @endpoint get /api/Admin/authorizedOrganizations
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAdminAuthorizedOrganizationsGet(
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<Array<Company>>;
  public apiAdminAuthorizedOrganizationsGet(
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<Array<Company>>>;
  public apiAdminAuthorizedOrganizationsGet(
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<Array<Company>>>;
  public apiAdminAuthorizedOrganizationsGet(
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/Admin/authorizedOrganizations`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<Company>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Register many devices of the same device family. (Role Permissions Required: TrackersRegister)
   * @endpoint post /api/Admin/bulkDevices
   * @param customerId The account to add these newly registered devices to.
   * @param deviceFamily The family of devices to be registered.
   * @param xTiveAccountId Account Id
   * @param requestBody A mapping of unique device IDs to their display names.
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAdminBulkDevicesPost(
    customerId?: number,
    deviceFamily?: DeviceFamily,
    xTiveAccountId?: number,
    requestBody?: { [key: string]: string },
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<RegisterDevicesResponse>;
  public apiAdminBulkDevicesPost(
    customerId?: number,
    deviceFamily?: DeviceFamily,
    xTiveAccountId?: number,
    requestBody?: { [key: string]: string },
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<RegisterDevicesResponse>>;
  public apiAdminBulkDevicesPost(
    customerId?: number,
    deviceFamily?: DeviceFamily,
    xTiveAccountId?: number,
    requestBody?: { [key: string]: string },
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<RegisterDevicesResponse>>;
  public apiAdminBulkDevicesPost(
    customerId?: number,
    deviceFamily?: DeviceFamily,
    xTiveAccountId?: number,
    requestBody?: { [key: string]: string },
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'customerId',
      <any>customerId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'deviceFamily',
      <any>deviceFamily,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json;odata.metadata=minimal;odata.streaming=true',
      'application/json;odata.metadata=minimal;odata.streaming=false',
      'application/json;odata.metadata=minimal',
      'application/json;odata.metadata=full;odata.streaming=true',
      'application/json;odata.metadata=full;odata.streaming=false',
      'application/json;odata.metadata=full',
      'application/json;odata.metadata=none;odata.streaming=true',
      'application/json;odata.metadata=none;odata.streaming=false',
      'application/json;odata.metadata=none',
      'application/json;odata.streaming=true',
      'application/json;odata.streaming=false',
      'application/json',
      'application/xml',
      'text/plain',
      'application/json-patch+json',
      'text/json',
      'application/*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/Admin/bulkDevices`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<RegisterDevicesResponse>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: requestBody,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Deactivate an organization.  Does not verify if there are active trackers in the account. (Role Permissions Required: ManageOrganizations)
   * @endpoint get /api/Admin/deactivateOrganization
   * @param organizationId
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAdminDeactivateOrganizationGet(
    organizationId?: string,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<boolean>;
  public apiAdminDeactivateOrganizationGet(
    organizationId?: string,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<boolean>>;
  public apiAdminDeactivateOrganizationGet(
    organizationId?: string,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<boolean>>;
  public apiAdminDeactivateOrganizationGet(
    organizationId?: string,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'organizationId',
      <any>organizationId,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/Admin/deactivateOrganization`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<boolean>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Update a device configuration entry. Messages are safe for direct consumption by Public API. (Role Permissions Required: TrackersRegister)
   * @endpoint put /api/Admin/devices/{deviceId}
   * @param deviceId The DeviceId for the device to be updated
   * @param xTiveAccountId Account Id
   * @param registerDevice The values to update for the device
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAdminDevicesDeviceIdPut(
    deviceId: string,
    xTiveAccountId?: number,
    registerDevice?: RegisterDevice,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<CheckDeviceResult>;
  public apiAdminDevicesDeviceIdPut(
    deviceId: string,
    xTiveAccountId?: number,
    registerDevice?: RegisterDevice,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<CheckDeviceResult>>;
  public apiAdminDevicesDeviceIdPut(
    deviceId: string,
    xTiveAccountId?: number,
    registerDevice?: RegisterDevice,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<CheckDeviceResult>>;
  public apiAdminDevicesDeviceIdPut(
    deviceId: string,
    xTiveAccountId?: number,
    registerDevice?: RegisterDevice,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    if (deviceId === null || deviceId === undefined) {
      throw new Error(
        'Required parameter deviceId was null or undefined when calling apiAdminDevicesDeviceIdPut.',
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json;odata.metadata=minimal;odata.streaming=true',
      'application/json;odata.metadata=minimal;odata.streaming=false',
      'application/json;odata.metadata=minimal',
      'application/json;odata.metadata=full;odata.streaming=true',
      'application/json;odata.metadata=full;odata.streaming=false',
      'application/json;odata.metadata=full',
      'application/json;odata.metadata=none;odata.streaming=true',
      'application/json;odata.metadata=none;odata.streaming=false',
      'application/json;odata.metadata=none',
      'application/json;odata.streaming=true',
      'application/json;odata.streaming=false',
      'application/json',
      'application/xml',
      'text/plain',
      'application/json-patch+json',
      'text/json',
      'application/*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/Admin/devices/${this.configuration.encodeParam({ name: 'deviceId', value: deviceId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<CheckDeviceResult>('put', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: registerDevice,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Register a device.  Any TiveInternalApiHttpException HTTP responses are passed on to Public API (manufacturing). (Role Permissions Required: TrackersRegister)
   * @endpoint post /api/Admin/devices
   * @param xTiveAccountId Account Id
   * @param registerDevice The registration values for a new device. Call Validate() before passing in.
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAdminDevicesPost(
    xTiveAccountId?: number,
    registerDevice?: RegisterDevice,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<CheckDeviceResult>;
  public apiAdminDevicesPost(
    xTiveAccountId?: number,
    registerDevice?: RegisterDevice,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<CheckDeviceResult>>;
  public apiAdminDevicesPost(
    xTiveAccountId?: number,
    registerDevice?: RegisterDevice,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<CheckDeviceResult>>;
  public apiAdminDevicesPost(
    xTiveAccountId?: number,
    registerDevice?: RegisterDevice,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json;odata.metadata=minimal;odata.streaming=true',
      'application/json;odata.metadata=minimal;odata.streaming=false',
      'application/json;odata.metadata=minimal',
      'application/json;odata.metadata=full;odata.streaming=true',
      'application/json;odata.metadata=full;odata.streaming=false',
      'application/json;odata.metadata=full',
      'application/json;odata.metadata=none;odata.streaming=true',
      'application/json;odata.metadata=none;odata.streaming=false',
      'application/json;odata.metadata=none',
      'application/json;odata.streaming=true',
      'application/json;odata.streaming=false',
      'application/json',
      'application/xml',
      'text/plain',
      'application/json-patch+json',
      'text/json',
      'application/*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/Admin/devices`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<CheckDeviceResult>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: registerDevice,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Login as another user from admin
   * @endpoint post /api/Admin/loginAsUser
   * @param username
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAdminLoginAsUserPost(
    username?: string,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<LoginUser>;
  public apiAdminLoginAsUserPost(
    username?: string,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<LoginUser>>;
  public apiAdminLoginAsUserPost(
    username?: string,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<LoginUser>>;
  public apiAdminLoginAsUserPost(
    username?: string,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'username',
      <any>username,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/Admin/loginAsUser`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<LoginUser>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Get Organization Info  &lt;param name&#x3D;\&quot;searchQuery\&quot;&gt;&lt;/param&gt; (Role Permissions Required: ManageOrganizations)
   * @endpoint get /api/Admin/organizationInfo
   * @param searchQuery
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAdminOrganizationInfoGet(
    searchQuery?: string,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<CompanyCustomerDeviceListItemListLengthResult>;
  public apiAdminOrganizationInfoGet(
    searchQuery?: string,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<CompanyCustomerDeviceListItemListLengthResult>>;
  public apiAdminOrganizationInfoGet(
    searchQuery?: string,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<CompanyCustomerDeviceListItemListLengthResult>>;
  public apiAdminOrganizationInfoGet(
    searchQuery?: string,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'searchQuery',
      <any>searchQuery,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/Admin/organizationInfo`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<CompanyCustomerDeviceListItemListLengthResult>(
      'get',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters.toHttpParams(),
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Returns Organization Summary View (Role Permissions Required: ManageOrganizations)
   * @endpoint get /api/Admin/organizationSummary
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAdminOrganizationSummaryGet(
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<Array<OrganizationListItem>>;
  public apiAdminOrganizationSummaryGet(
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<Array<OrganizationListItem>>>;
  public apiAdminOrganizationSummaryGet(
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<Array<OrganizationListItem>>>;
  public apiAdminOrganizationSummaryGet(
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/Admin/organizationSummary`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<OrganizationListItem>>(
      'get',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Get Organization Summary with OData
   * @endpoint get /api/Admin/organizationSummary/odata
   * @param xTiveAccountId Account Id
   * @param $apply Apply a set of transformations to the result set
   * @param $select A list of columns to be returned.
   * @param $search A string search term to filter the results list.
   * @param $top The max number of records.
   * @param $skip The number of records to skip.
   * @param $filter A function that must evaluate to true for a record to be returned.
   * @param $orderby Determines what values are used to order a collection of records.
   * @param $expand Use to add related query data.
   * @param $count Request only the count of records. (true|false)
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAdminOrganizationSummaryOdataGet(
    xTiveAccountId?: number,
    $apply?: string,
    $select?: string,
    $search?: string,
    $top?: string,
    $skip?: string,
    $filter?: string,
    $orderby?: string,
    $expand?: string,
    $count?: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<ODataResponse>;
  public apiAdminOrganizationSummaryOdataGet(
    xTiveAccountId?: number,
    $apply?: string,
    $select?: string,
    $search?: string,
    $top?: string,
    $skip?: string,
    $filter?: string,
    $orderby?: string,
    $expand?: string,
    $count?: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<ODataResponse>>;
  public apiAdminOrganizationSummaryOdataGet(
    xTiveAccountId?: number,
    $apply?: string,
    $select?: string,
    $search?: string,
    $top?: string,
    $skip?: string,
    $filter?: string,
    $orderby?: string,
    $expand?: string,
    $count?: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<ODataResponse>>;
  public apiAdminOrganizationSummaryOdataGet(
    xTiveAccountId?: number,
    $apply?: string,
    $select?: string,
    $search?: string,
    $top?: string,
    $skip?: string,
    $filter?: string,
    $orderby?: string,
    $expand?: string,
    $count?: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      '$apply',
      <any>$apply,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      '$select',
      <any>$select,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      '$search',
      <any>$search,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      '$top',
      <any>$top,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      '$skip',
      <any>$skip,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      '$filter',
      <any>$filter,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      '$orderby',
      <any>$orderby,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      '$expand',
      <any>$expand,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      '$count',
      <any>$count,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/Admin/organizationSummary/odata`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<ODataResponse>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Receives devices (Role Permissions Required: TrackersAssignToOrganization)
   * @endpoint post /api/Admin/receiveDevices
   * @param xTiveAccountId Account Id
   * @param receiveDevicesRequest
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAdminReceiveDevicesPost(
    xTiveAccountId?: number,
    receiveDevicesRequest?: ReceiveDevicesRequest,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<boolean>;
  public apiAdminReceiveDevicesPost(
    xTiveAccountId?: number,
    receiveDevicesRequest?: ReceiveDevicesRequest,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<boolean>>;
  public apiAdminReceiveDevicesPost(
    xTiveAccountId?: number,
    receiveDevicesRequest?: ReceiveDevicesRequest,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<boolean>>;
  public apiAdminReceiveDevicesPost(
    xTiveAccountId?: number,
    receiveDevicesRequest?: ReceiveDevicesRequest,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json;odata.metadata=minimal;odata.streaming=true',
      'application/json;odata.metadata=minimal;odata.streaming=false',
      'application/json;odata.metadata=minimal',
      'application/json;odata.metadata=full;odata.streaming=true',
      'application/json;odata.metadata=full;odata.streaming=false',
      'application/json;odata.metadata=full',
      'application/json;odata.metadata=none;odata.streaming=true',
      'application/json;odata.metadata=none;odata.streaming=false',
      'application/json;odata.metadata=none',
      'application/json;odata.streaming=true',
      'application/json;odata.streaming=false',
      'application/json',
      'application/xml',
      'text/plain',
      'application/json-patch+json',
      'text/json',
      'application/*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/Admin/receiveDevices`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<boolean>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: receiveDevicesRequest,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Validate various data required to make an assignment of devices to an account with the ability to perform a check (Role Permissions Required: UserValidateAssignment)
   * @endpoint post /api/Admin/validatedAssignment
   * @param assignIfValid If True, assign devices to destination account after validation
   * @param assignFromAnyAccount True skips source account check
   * @param xTiveAccountId Account Id
   * @param assignmentItem JSON to validate
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAdminValidatedAssignmentPost(
    assignIfValid?: boolean,
    assignFromAnyAccount?: boolean,
    xTiveAccountId?: number,
    assignmentItem?: AssignmentItem,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<AssignmentValidationResponse>;
  public apiAdminValidatedAssignmentPost(
    assignIfValid?: boolean,
    assignFromAnyAccount?: boolean,
    xTiveAccountId?: number,
    assignmentItem?: AssignmentItem,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<AssignmentValidationResponse>>;
  public apiAdminValidatedAssignmentPost(
    assignIfValid?: boolean,
    assignFromAnyAccount?: boolean,
    xTiveAccountId?: number,
    assignmentItem?: AssignmentItem,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<AssignmentValidationResponse>>;
  public apiAdminValidatedAssignmentPost(
    assignIfValid?: boolean,
    assignFromAnyAccount?: boolean,
    xTiveAccountId?: number,
    assignmentItem?: AssignmentItem,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'assignIfValid',
      <any>assignIfValid,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'assignFromAnyAccount',
      <any>assignFromAnyAccount,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json;odata.metadata=minimal;odata.streaming=true',
      'application/json;odata.metadata=minimal;odata.streaming=false',
      'application/json;odata.metadata=minimal',
      'application/json;odata.metadata=full;odata.streaming=true',
      'application/json;odata.metadata=full;odata.streaming=false',
      'application/json;odata.metadata=full',
      'application/json;odata.metadata=none;odata.streaming=true',
      'application/json;odata.metadata=none;odata.streaming=false',
      'application/json;odata.metadata=none',
      'application/json;odata.streaming=true',
      'application/json;odata.streaming=false',
      'application/json',
      'application/xml',
      'text/plain',
      'application/json-patch+json',
      'text/json',
      'application/*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/Admin/validatedAssignment`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<AssignmentValidationResponse>(
      'post',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: assignmentItem,
        params: localVarQueryParameters.toHttpParams(),
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Returns permissions the user should have when viewing as a company (Role Permissions Required: UserViewAsOrg)
   * @endpoint get /api/Admin/viewAsCompanyPermissions
   * @param companyId
   * @param keepTivePermissions
   * @param accountId
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAdminViewAsCompanyPermissionsGet(
    companyId?: string,
    keepTivePermissions?: boolean,
    accountId?: number,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<Array<Permissions>>;
  public apiAdminViewAsCompanyPermissionsGet(
    companyId?: string,
    keepTivePermissions?: boolean,
    accountId?: number,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<Array<Permissions>>>;
  public apiAdminViewAsCompanyPermissionsGet(
    companyId?: string,
    keepTivePermissions?: boolean,
    accountId?: number,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<Array<Permissions>>>;
  public apiAdminViewAsCompanyPermissionsGet(
    companyId?: string,
    keepTivePermissions?: boolean,
    accountId?: number,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'companyId',
      <any>companyId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'keepTivePermissions',
      <any>keepTivePermissions,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'accountId',
      <any>accountId,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/Admin/viewAsCompanyPermissions`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<Permissions>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }
}
